<template>
  <div class="text-dark fs-4 fw-bold">
    <div class="position-absolute" style="top: 40px; left: 43%">A</div>
    <div class="position-absolute" style="top: 0px; left: 52%">B</div>
    <div class="position-absolute" style="top: 25px; left: 78.5%">C</div>
  </div>
</template>
